import React from "react";
import { User } from "~/common/Store/models/User";
import GlobalIcon from "./Icons/GlobalIcon";
import BoltIcon from "./Icons/BoltIcon";
import DollarIcon from "./Icons/DollarIcon";
import ListIcon from "./Icons/ListIcon";
import StarIcon from "./Icons/StarIcon";
import getContainerClasses from "./getContainerClasses";
import CaretIcon from "~/HomePage/Shared/CaretIcon";
interface Props {
  user: User;
  showingMessages: boolean;
}
const UserPrivileges = ({
  user,
  showingMessages
}: Props) => {
  const {
    isSupervisor,
    orderGuideEnabled
  } = user;
  const linkStyle = "font-semibold text-sm leading-none text-gray-800 hover:text-gray-700 flex flex-row justify-start items-center transition-all duration-75 ease-in-out";
  return <div className={getContainerClasses(showingMessages, !!isSupervisor, !!orderGuideEnabled)} data-testid="platinum-feature-buttons" data-sentry-component="UserPrivileges" data-sentry-source-file="index.tsx">
      <a href="/reorder.html" className={linkStyle}>
        <BoltIcon data-sentry-element="BoltIcon" data-sentry-source-file="index.tsx" />
        Rapid Reorder
        <CaretIcon data-sentry-element="CaretIcon" data-sentry-source-file="index.tsx" />
      </a>
      <a href="/request-quote.html" className={linkStyle}>
        <DollarIcon data-sentry-element="DollarIcon" data-sentry-source-file="index.tsx" />
        Quotes
        <CaretIcon data-sentry-element="CaretIcon" data-sentry-source-file="index.tsx" />
      </a>
      {isSupervisor && <a href="/myaccount/supervisor-system/" className={linkStyle}>
          <GlobalIcon />
          Supervisor System
          <CaretIcon />
        </a>}
      <a href="/wishlist.html" className={linkStyle}>
        <StarIcon data-sentry-element="StarIcon" data-sentry-source-file="index.tsx" />
        Wishlist
        <CaretIcon data-sentry-element="CaretIcon" data-sentry-source-file="index.tsx" />
      </a>
      {orderGuideEnabled && <a href="/myproducts.html" className={linkStyle}>
          <ListIcon />
          Order Guide
          <CaretIcon />
        </a>}
    </div>;
};
export default UserPrivileges;